export enum dreVisions {
  // boxVision = 1, // removed, according to ticket 2026042871000474
  gerencialVision = 2,
  competencyVision = 3
}
